export default function socialSharingActions() {
    const getCurrentUrl = () => encodeURIComponent(window.location.href);

    const shareOnFacebook = () => {
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${getCurrentUrl()}`;
        window.open(facebookUrl, '_blank');
    };

    const shareOnTwitter = () => {
        const twitterUrl = `https://twitter.com/intent/tweet?url=${getCurrentUrl()}`;
        window.open(twitterUrl, '_blank');
    };

    const shareOnLinkedIn = () => {
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${getCurrentUrl()}`;
        window.open(linkedInUrl, '_blank');
    };

    return {
        shareOnFacebook,
        shareOnTwitter,
        shareOnLinkedIn,
    };
}
